var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"button",class:_vm.classes,attrs:{"type":_vm.type}},_vm.$listeners),[_c('span',[_vm._t("default",[_vm._v("Button")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }